import { createLayoutKeyObject } from "./layout";

export enum DragDropActionTypes {
  CREATE_POS_LAYOUT = "CREATE_POS_LAYOUT",
  DELETE_POS_LAYOUT = "DELETE_POS_LAYOUT",
  UPDATE_POS_LAYOUT_KEY = "UPDATE_POS_LAYOUT_KEY",
  UPDATE_POS_LAYOUT = "UPDATE_POS_LAYOUT",
  MOVE_POS_LAYOUT_KEY = "MOVE_POS_LAYOUT_KEY",
  SWAP_POS_LAYOUT_KEYS = "SWAP_POS_LAYOUT_KEYS",
  SHIFT_POS_LAYOUT_KEYS = "SHIFT_POS_LAYOUT_KEYS",
  DELETE_POS_LAYOUT_KEY = "DELETE_POS_LAYOUT_KEY",
  CREATE_POS_LAYOUT_KEY = "CREATE_POS_LAYOUT_KEY",
  APPLY_DEFAULT_LAYOUT_CONFIGURATION = "APPLY_DEFAULT_LAYOUT_CONFIGURATION",
  UPDATE_LAYOUT_NODE_POSITIONS = "UPDATE_LAYOUT_NODE_POSITIONS",
}

export type LayoutKey = ReturnType<typeof createLayoutKeyObject>;

export const orientations = {
  PORTRAIT: "portrait",
  PORTRAIT_UPSIDE_DOWN: "portrait-upside-down",
  LANDSCAPE: "landscape",
  LANDSCAPE_LEFT: "landscape-left",
  LANDSCAPE_RIGHT: "landscape-right",
} as const;

export const allOrientations = Object.values(orientations);

export const holdScale = 1.05;
